/**
 * Hard cap on the free-text "Observaciones para factura"
 * (`sales_request.factura_observations`).
 *
 * The factura PDF is rendered by BSale from a fixed-height OBSERVACIONES box
 * on the print template. The glosa also carries the auto-added
 * "Dirección de entrega:" and the totem comodato notice, so the box clips on
 * long notes. 450 chars keeps the printed note from clipping in almost all
 * cases while still allowing a reasonable precinto list.
 */
export const FACTURA_OBSERVATIONS_MAX_LENGTH = 450;
